import { render, staticRenderFns } from "./banner-content.vue?vue&type=template&id=61148715&scoped=true&"
import script from "./banner-content.vue?vue&type=script&lang=js&"
export * from "./banner-content.vue?vue&type=script&lang=js&"
import style0 from "./banner-content.vue?vue&type=style&index=0&id=61148715&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61148715",
  null
  
)

export default component.exports